module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Bargen-1a6027067e34d89524a3091f0417cf47.png";